import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { IDomain } from './domain';
import { IDomainFormValues } from './domainFormValues';
import { IDomainUpsert } from './domainUpsert';

export default class DomainModelHelper {
    public static createFormValues = (domain : IDomain | null) : IDomainFormValues => {
        if (!domain) return {
            id: 0,
            guid: uuidV4(),
            domainName: '',
            isActive: true,
        };

        return {
            id: domain.id,
            guid: domain.guid,
            domainName: domain.domainName,
            isActive: domain.isActive,
        };
    };

    public static createUpsert = (formValues : IDomainFormValues) : IDomainUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            domainName: formValues.domainName,
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<IDomainFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        domainName: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        isActive: Yup.boolean().required('Required'),
    });
}
